import { createSelector } from 'reselect';
import { navSelector } from 'common/store/modules/competition-nav/selectors';

/**
 * @returns {( object ) => object|null} Season.
 */
export const seasonSelector = createSelector(
    navSelector,
    (state) => state.seasons,
    (nav, seasons) => {
        try {
            return seasons[`competition_${nav.competition.id}`][
                `season_${nav.season.id}`
            ];
        } catch (err) {
            return null;
        }
    }
);
